import { render } from "./VideoPlayerOverlayMeta.vue?vue&type=template&id=482d4e8c&ts=true"
import script from "./VideoPlayerOverlayMeta.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerOverlayMeta.vue?vue&type=script&lang=ts"

import "./VideoPlayerOverlayMeta.vue?vue&type=style&index=0&id=482d4e8c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__